import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../common/constants/api-url.constant';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Content } from '../../common/models/content.type';
import { ContentType } from '../../common/enum/content-type.enum';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionService {
  private http = inject(HttpClient);
  private apiConstants = inject(ApiConstants);

  /**
   * Get Terms or Policy by type
   * @param type ContentType enum
   * @returns Observable<Content>
   */
  getTermAndCondition(type: ContentType): Observable<Content> {
    return this.http.get<Content>(this.apiConstants.GET_POLICY(type)).pipe(
      map((response: Content) => {
        // Optional: transform response if needed
        return response;
      }),
      catchError((error) => {
        console.error('Error fetching terms and conditions:', error);
        return throwError(() => new Error('Failed to fetch terms and conditions.'));
      })
    );
  }
}
